import {
  FORUM_LIST_REQUEST,
  FORUM_LIST_PUBLISH_REQUEST,
  FORUM_LIST_COLLECT_REQUEST,
  FORUM_ACTION_REMOVE_REQUEST,
  FORUM_ACTION_SET_REQUEST,
  FORUM_ASS_WORD_REQUEST,
  FORUM_ASS_WORD_SUCCESS,
  FORUM_UPLOAD_PARAMS_REQUEST,
  FORUM_INFO_REQUEST,
  FORUM_CONTENT_REQUEST,
  FORUM_SUBMIT_REQUEST,
  FORUM_DELETE_REQUEST,
  FORUM_COMMENT_ADD_REQUEST,
  FORUM_COMMENT_ZAN_REQUEST,
  FORUM_COMMENT_REVIEW_REQUEST,
  FORUM_COMMENT_LIST_REQUEST,
  FORUM_COMMENT_GRADE_REQUEST,
  FORUM_COMMENT_LOADING,
  FORUM_COMMENT_REVIEW_SHOW,
  FORUM_COMMENT_LIST_COLLAPSE,
} from '../constants/forum';

export const getForumList = param => ({
  type: FORUM_LIST_REQUEST,
  ...param,
});

export const getForumListPub = param => ({
  type: FORUM_LIST_PUBLISH_REQUEST,
  ...param,
});

export const getForumListCol = param => ({
  type: FORUM_LIST_COLLECT_REQUEST,
  ...param,
});

// 接口获取联想的soft
export const getLenovoSoft = param => ({
  type: FORUM_ASS_WORD_REQUEST,
  ...param,
});
// 获取联想的soft
export const setLenovoSoft = param => ({
  type: FORUM_ASS_WORD_SUCCESS,
  payload: { ...param },
});

// 产出帖子
export const deleteForum = param => ({
  type: FORUM_DELETE_REQUEST,
  ...param,
});

// 获取帖子详情
export const getForumDetail = param => ({
  type: FORUM_INFO_REQUEST,
  ...param,
});
// 获取帖子更多详情
export const getForumDetailMore = param => ({
  type: FORUM_CONTENT_REQUEST,
  ...param,
});

// 提交评论
export const postForumAddComment = param => ({
  type: FORUM_COMMENT_ADD_REQUEST,
  param,
});
// 提交评论回复
export const postForumAddReview = param => ({
  type: FORUM_COMMENT_REVIEW_REQUEST,
  param,
});
// 评论回复点赞
export const postForumAddZan = param => ({
  type: FORUM_COMMENT_ZAN_REQUEST,
  param,
});
// 评论列表获取
export const getForumCommentList = param => ({
  type: FORUM_COMMENT_LIST_REQUEST,
  param,
});
// 评分统计计算
export const postForumCommentGrage = param => ({
  type: FORUM_COMMENT_GRADE_REQUEST,
  ...param,
});
// 评论加载状态
export const setForumCommentLoad = param => ({
  type: FORUM_COMMENT_LOADING,
  payload: param,
});

export const setShowForumReview = param => {
  return {
    type: FORUM_COMMENT_REVIEW_SHOW,
    payload: param,
  };
};
// 帖子点赞、收藏
export const setForumAction = param => ({
  type: FORUM_ACTION_SET_REQUEST,
  param,
});
// 取消帖子的点赞收藏
export const removeForumAction = param => ({
  type: FORUM_ACTION_REMOVE_REQUEST,
  param,
});

// 更改帖子回复列表的折叠状态
export const setForumCommentCollpase = param => ({
  type: FORUM_COMMENT_LIST_COLLAPSE,
  payload: param,
});
